import { render, staticRenderFns } from "./CloseSVG.vue?vue&type=template&id=a13a8a9c&"
import script from "./CloseSVG.vue?vue&type=script&lang=js&"
export * from "./CloseSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports